// Shares the volunteer menu's look, so both people lists feel the same.
import '@components/VolunteerContextMenu/index.scss';

import ContextMenu from '@components/ContextMenu';
import { TrashCanIcon } from '@components/SongContextMenu';

import pencilIcon from 'url:@assets/icons/pencil.svg';

export type StaffContextMenuProps = {
  x: number;
  y: number;
  isClosing: boolean;
  onRequestClose?: () => void;
  onEdit: () => void;
  onDelete: () => void;
  // Off for the signed-in user's own account, which the API won't delete.
  canDelete?: boolean;
};

export default function StaffContextMenu(props: StaffContextMenuProps) {
  return <ContextMenu
    className='volunteer-context-menu'
    x={props.x}
    y={props.y}
    isClosing={props.isClosing}
    onRequestClose={props.onRequestClose}
    sections={[
      {
        className: 'volunteer-context-menu-actions',
        items: [
          {
            key: 'edit',
            className: 'volunteer-context-action',
            onClick: props.onEdit,
            content: <>
              <img src={pencilIcon} alt='' aria-hidden='true' />
              <span>Edit</span>
            </>
          }
        ]
      },
      {
        className: 'volunteer-context-menu-actions',
        items: [
          {
            key: 'delete',
            className: 'volunteer-context-action destructive',
            disabled: props.canDelete === false,
            onClick: props.onDelete,
            content: <>
              <TrashCanIcon />
              <span>Delete</span>
            </>
          }
        ]
      }
    ]}
  />;
}
